<div>
	<div class="row">
		<div class="col"></div>
		<div class="col-auto">
			<button type="button" class="btn btn-primary" [routerLink]="['/Asset/assetaddition/add/',0]"
				[disabled]="isDisabled">
				<i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
				<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
					*ngIf="isDisabled"></span>
				{{!isDisabled?'Add Asset':'Loading...'}}
			</button>
		</div>
	</div>
	<div class="card border-radius-0 mt-1 p-0">
		<div class="card-header">
			Asset Details
		</div>
		<div class="card-body p-1">
			<table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="customeDatatable table table-bordered">
				<thead class="table-light">
					<tr>
						<th scope="col" style="width: 5px;">#</th>
						<!-- <th>Asset Name</th> -->
						<th>Purchase Reference No</th>
						<th>Purchase Date</th>
						<th>Vendor Name</th>
						<th>Branch</th>
						<th>Total Asset Count</th>
						<th>Attachment</th>
						<th style="width: 5px;">Action</th>
					</tr>
				</thead>
				<tbody>
					<tr *ngFor="let TableData of TableDatas; let i = index">
						<th scope="row" style="width: 5px;">{{i+1}}</th>
						<!-- <td  class="text-primary cursor-pointer" ><i [routerLink]="['/Asset/assetadditionDetail/add/',TableData['ESS_AssetAdditionId']]" >{{TableData['AssetMasterName']}}</i></td> -->
						<td class="text-primary cursor-pointer"><i
								[routerLink]="['/Asset/assetadditionDetail/add/',TableData['ESS_AssetAdditionId']]">{{TableData['PurchaseRefNo']}}</i>
						</td>
						<td>{{TableData['PurchaseDate'] | date: 'dd MMM yyyy'}}</td>
						<td>{{TableData['VendorName']}}</td>
						<td>{{TableData['BranchName']}}</td>
						<td>{{TableData['TotalCount']}}</td>
						<td>
							<div style="width: 80px;"><a [href]="Link(TableData['Attachment'])" target="_blank"
									class="btn btn-outline-primary btn-sm" role="button"><i
										class="bi bi-paperclip"></i>View</a></div>
						</td>
						<td style="width: 5px;">
							<div class="text-center"><i
									[routerLink]="['/Asset/assetaddition/add/',TableData['ESS_AssetAdditionId']]"
									class="bi bi-pencil-square text-warning"></i></div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</div>